import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { TeamDetailPage } from '@/features/org/components/team-detail-page'
import { TEAMS_SEARCH_DEFAULTS, teamsSearchSchema } from '@/features/org/search-schema'

/**
 * /teams/$teamId —— 团队详情(基本信息 + 下级团队卡 + 成员表)。
 * 沿用列表 search schema,「返回列表」能落回来时那一屏。
 */
export const Route = createFileRoute('/_authed/teams/$teamId/')({
  validateSearch: teamsSearchSchema,
  search: {
    middlewares: [stripSearchParams(TEAMS_SEARCH_DEFAULTS)],
  },
  component: TeamDetailPage,
})
